/** What an HTTP refusal says, read off an axios error (`response`) or a
 *  fetch-style one (TelegramOidcError: `status`, `detail`). Both fields are
 *  absent for anything that never got an answer, such as a network failure. */
export const refusalOf = (error: unknown): { status?: number; detail?: unknown } => {
  const failure = error as {
    response?: { status?: number; data?: { detail?: unknown } };
    status?: number;
    detail?: unknown;
  } | null;
  if (failure?.response) {
    return { status: failure.response.status, detail: failure.response.data?.detail };
  }
  return { status: failure?.status, detail: failure?.detail };
};
